module.exports = __webpack_public_path__ + "img/certificate-2-3.1ad6349c.jpg";